<template>
	<aside class="b-aside">
    <ul class="b-aside__nav">
      <li class="b-aside__nav-item">
        <button class="b-aside__menu-btn" @click="toggleAside">
          <dynamic-icon icon="menu"/>
        </button>
      </li>
      <AsideNavItem :nav="nav" v-for="nav in navigation" :key="nav.id" />
    </ul>
	</aside>
</template>

<script>
import AsideNavItem from './AsideNavItem.vue';

export default {
  name: 'aside-component',
  components: {
    AsideNavItem,
  },
  data() {
    return {
      asideHide: false,
      asideHideSettings: false,
      navigation: [
        {
          name: `${this.$t('CONTENT.registry')}`,
          icon: 'doc',
          linkName: 'Registry',
        },
        {
          name: `${this.$t('CONTENT.reportPage.reports')}`,
          icon: 'report',
          linkName: 'Reports',
        },
      ],
    };
  },
  created() {
    window.onresize = this.checkScreenSize;
    this.checkScreenSize();
    document.body.classList.add('b-aside--hidden');
    this.role = localStorage.getItem('role');
    if (this.role !== 'Auditor') {
      this.navigation.push(
        {
          name: `${this.$t('CONTENT.directories')}`,
          icon: 'catalog',
          linkName: 'Counterparty',
        },
        {
          name: `${this.$t('CONTENT.settingsPage.settings')}`,
          icon: 'settings',
          linkName: 'Settings',
        },
      );
    }
    this.navigation.push({
      name: `${this.$t('CONTENT.aboutPage.about')}`,
      icon: 'info',
      linkName: 'About',
    });
  },
  methods: {
    toggleAside() {
      document.body.classList.toggle('b-aside--hidden');
      this.asideHide = !this.asideHide;
    },
    checkScreenSize() {
      if (
        window.innerWidth < 1600
				&& !document.body.classList.contains('b-aside--hidden')
      ) {
        this.toggleAside();
      }
    },
  },
};
</script>
